<help-modal>
  <div class="modal fade" id="helpScheduleModal" tabindex="-1" aria-labelledby="helpScheduleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-info bg-opacity-10">
          <h5 class="modal-title" id="helpScheduleModalLabel">
            <i class="bi bi-info-circle me-2"></i>
            Ayuda del Sistema de Calendarización
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>Sistema de Calendarización</h4>

          <div class="alert alert-info">
            <i class="bi bi-lightbulb me-2"></i>
            El sistema de calendarización permite configurar horarios específicos para la apertura automática de
            puertas.
          </div>

          <h5 class="mt-4">Conceptos Básicos</h5>
          <div class="row mb-4">
            <div class="col-md-6">
              <div class="card h-100">
                <div class="card-header">
                  <i class="bi bi-calendar-week me-2"></i>Horarios Regulares
                </div>
                <div class="card-body">
                  <p>Define los días y horas en que las puertas estarán operativas de manera habitual.</p>
                  <ul>
                    <li>Selecciona los días de la semana activos</li>
                    <li>Define uno o más rangos de horas para cada día</li>
                    <li>Las puertas solo se abrirán durante estos horarios</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card h-100">
                <div class="card-header">
                  <i class="bi bi-calendar-x me-2"></i>Excepciones
                </div>
                <div class="card-body">
                  <p>Define fechas específicas con comportamientos diferentes al horario regular:</p>
                  <ul>
                    <li><strong>Apertura especial:</strong> Permite abrir en días no habituales</li>
                    <li><strong>Cierre por festivo:</strong> Bloquea la apertura en días específicos</li>
                    <li>Puedes configurar horarios personalizados para cada excepción</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <h5>Configuración de Horarios</h5>
          <div class="table-responsive mb-4">
            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th>Elemento</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Habilitar restricción horaria</td>
                  <td>Activa o desactiva todo el sistema de calendarización para el canal seleccionado</td>
                </tr>
                <tr>
                  <td>Zona horaria</td>
                  <td>Define la zona horaria aplicable a los horarios configurados</td>
                </tr>
                <tr>
                  <td>Días activos</td>
                  <td>Selecciona qué días de la semana se aplicará el horario regular</td>
                </tr>
                <tr>
                  <td>Rangos de hora</td>
                  <td>Períodos específicos durante los días activos cuando la puerta puede abrirse</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h5>Configuración de Excepciones</h5>
          <p>Las excepciones permiten gestionar días especiales como festivos, vacaciones o eventos:</p>

          <div class="card mb-4">
            <div class="card-body">
              <h6><i class="bi bi-toggle-on me-2 text-success"></i>Excepción Habilitada</h6>
              <p>Cuando una excepción está <strong>habilitada</strong>, la puerta podrá abrirse durante la fecha
                configurada, incluso si no coincide con los días activos regulares. Puedes establecer horarios
                específicos o usar los predeterminados.</p>

              <h6 class="mt-3"><i class="bi bi-toggle-off me-2 text-danger"></i>Excepción Deshabilitada</h6>
              <p>Cuando una excepción está <strong>deshabilitada</strong>, la puerta permanecerá cerrada durante toda la
                fecha configurada, incluso si coincide con un día activo regular. Útil para festivos o cierres
                programados.</p>
            </div>
          </div>

          <h5>Ejemplos de Uso</h5>
          <div class="accordion" id="accordionExamples">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                  Ejemplo 1: Oficina con horario de lunes a viernes
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExamples">
                <div class="accordion-body">
                  <ul>
                    <li>Días activos: Lunes a Viernes</li>
                    <li>Horario: 8:00 - 19:00</li>
                    <li>Excepciones (deshabilitadas) para festivos nacionales</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Ejemplo 2: Almacén con horario partido
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                data-bs-parent="#accordionExamples">
                <div class="accordion-body">
                  <ul>
                    <li>Días activos: Lunes a Sábado</li>
                    <li>Rangos de hora:
                      <ul>
                        <li>10:00 - 14:00</li>
                        <li>16:30 - 20:30</li>
                      </ul>
                    </li>
                    <li>Excepciones para domingos especiales de apertura</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Entendido</button>
        </div>
      </div>
    </div>

  </div>

  <script>
    import { Modal } from 'bootstrap';

    export default {
      onMounted() {
        // Inicializar el modal cuando el componente se monte
        const modalElement = document.getElementById('helpScheduleModal');
        if (modalElement) {
          // Almacenar la instancia directamente en window para acceso global
          window.helpScheduleModal = new Modal(modalElement);
        }
      },
    }
  </script>

</help-modal>
